import React from "react";
import AboutSection from "../Components/AboutSection";
import AuthorizedSales from "../Components/AuthorizedSales";
import IN from "../assets/flags/India.png";
import SA from "../assets/flags/SouthAfrica.png";
import calibrationImg from "../assets/callibration.jpg";
import testingImg from "../assets/testing.jpg";
import pharmaImg from "../assets/pharma.jpg";
import thirdImg from "../assets/third.jpg";
import manufacturingImg from "../assets/manufacturing.PNG";

const About = () => {
  const industries = [
    { name: "Calibration Labs", img: calibrationImg },
    { name: "Testing Labs", img: testingImg },
    { name: "Pharma", img: pharmaImg },
    { name: "Third Party Inspection", img: thirdImg },
    { name: "Manufacturing", img: manufacturingImg },
  ];

  return (
    <div className="bg-white min-h-screen">

      {/* banner */}
      <div data-theme="dark" className="h-48 md:h-64 relative flex items-center justify-center text-white overflow-hidden bg-gradient-to-b from-[#060b13] via-[#0b172a] to-[#050a12] rounded-b-[2.5rem] border-b border-blue-900/30 pt-[82px]">
        <div
          className="absolute inset-0 opacity-15"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.06) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.06) 1px,transparent 1px)",
            backgroundSize: "28px 28px",
          }}
        />
        {/* gradient blobs */}
        <div className="absolute top-0 right-0 w-72 h-72 rounded-full bg-blue-600/25 blur-[80px] pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-indigo-600/15 blur-[80px] pointer-events-none" />

        <h1
          className="text-3xl md:text-5xl lg:text-6xl font-bold tracking-[4px] md:tracking-[8px] text-white relative z-10 uppercase font-teko"
          data-aos="fade-up"
        >
          About Us
        </h1>
      </div>

      {/* founder */}
      <AboutSection />

      {/* vision & mission */}
      <section className="relative py-12 md:py-20 bg-blue-900 border-b border-slate-200 overflow-hidden text-white">
        <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-blue-400 via-blue-800 to-slate-900" />
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.05) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.05) 1px,transparent 1px)",
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8 text-center" data-aos="fade-up">
          <div className="mb-3">
            <span className="text-blue-200 font-bold tracking-widest uppercase text-[10px] border-b-2 border-white/50 pb-1">
              Core Values
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-teko uppercase tracking-wide mb-8 md:mb-12">
            Fundamental Principles
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 lg:gap-12 text-left">
            {/* vision */}
            <div className="bg-white/5 p-6 md:p-8 border border-white/10 rounded backdrop-blur-sm hover:bg-white/10 transition-colors duration-300 shadow-xl">
              <h2 className="font-bold tracking-wider text-xl md:text-2xl text-blue-300 mb-4 md:mb-6 border-b border-white/20 pb-3 md:pb-4">
                OUR VISION
              </h2>
              <ul className="space-y-3 md:space-y-4 text-base md:text-lg font-medium tracking-wide">
                {[
                  "Leading Industrial Software Provider",
                  "Build World-Class SaaS Products",
                  "Empower Laboratories & Industries",
                  "Support Quality-Driven Organizations",
                  "Innovating Tomorrow's Technology",
                  "Expand Across Global Markets",
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <span className="w-2 h-2 rounded-full bg-blue-400 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* mission */}
            <div className="bg-white/5 p-6 md:p-8 border border-white/10 rounded backdrop-blur-sm hover:bg-white/10 transition-colors duration-300 shadow-xl">
              <h2 className="font-bold tracking-wider text-xl md:text-2xl text-blue-300 mb-4 md:mb-6 border-b border-white/20 pb-3 md:pb-4">
                OUR MISSION
              </h2>
              <ul className="space-y-3 md:space-y-4 text-base md:text-lg font-medium tracking-wide">
                {[
                  "Simplify Complex Operations",
                  "Deliver Innovative Software Solutions",
                  "Ensure Compliance-Driven Systems",
                  "Improve Productivity & Accuracy",
                  "Support Industrial Digital Growth",
                  "Drive Business Success",
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <span className="w-2 h-2 rounded-full bg-blue-400 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* industries */}
      <section className="bg-white py-12 md:py-20 px-5 border-b border-slate-200">
        <div className="max-w-7xl mx-auto text-center" data-aos="fade-up">
          <div className="mb-3">
            <span className="text-blue-600 font-bold tracking-widest uppercase text-[10px] border-b-2 border-blue-400 pb-1">
              Sectors
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-teko uppercase text-slate-900 tracking-wide mb-8 md:mb-12">
            Industries We Serve
          </h2>

          {/* grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
            {industries.map((industry, index) => (
              <div
                key={index}
                className="flex flex-col items-center justify-center p-5 md:p-8 bg-slate-50 border border-slate-200 shadow-sm rounded-2xl md:rounded-3xl hover:-translate-y-1 md:hover:-translate-y-2 hover:shadow-xl hover:bg-white hover:border-blue-500 transition-all duration-500 group"
              >
                <div className="w-14 h-14 md:w-20 md:h-20 mb-4 md:mb-6 rounded-xl md:rounded-2xl overflow-hidden bg-white p-1.5 md:p-2 shadow-inner border border-slate-100 group-hover:scale-110 transition-transform duration-500">
                  <img
                    src={industry.img}
                    alt={industry.name}
                    className="w-full h-full object-contain"
                  />
                </div>
                <span className="font-bold text-slate-800 text-[10px] md:text-[13px] text-center uppercase tracking-wider leading-snug">
                  {industry.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* countries */}
      <section className="bg-slate-50 py-12 md:py-20 px-5 border-b border-slate-200">
        <div className="max-w-7xl mx-auto text-center" data-aos="fade-up">
          <div className="mb-3">
            <span className="text-blue-600 font-bold tracking-widest uppercase text-[10px] border-b-2 border-blue-400 pb-1">
              Global Reach
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-teko uppercase text-slate-900 tracking-wide mb-8 md:mb-12">
            Countries We Serve
          </h2>
          <div className="flex flex-wrap justify-center gap-5 md:gap-8">
            {[
              { flag: IN, alt: "India Flag", name: "India" },
              { flag: SA, alt: "South Africa Flag", name: "South Africa" },
            ].map((c, i) => (
              <div
                key={i}
                className="flex flex-col items-center justify-center p-5 md:p-6 bg-white border border-slate-200 shadow-sm rounded w-36 md:w-48 hover:-translate-y-1 hover:shadow-md hover:border-blue-300 transition-all duration-300"
              >
                <img
                  src={c.flag}
                  alt={c.alt}
                  className="h-12 md:h-16 mb-3 md:mb-4 rounded shadow-sm border border-slate-100"
                />
                <span className="font-bold text-slate-800 text-sm md:text-lg uppercase tracking-tight text-center">
                  {c.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <AuthorizedSales />
    </div>
  );
};

export default About;
